import { useRef, useCallback } from 'react';

interface VolumeSliderProps {
  value: number; // 0-1
  onChange: (value: number) => void;
  onChangeEnd?: () => void;
}

export function VolumeSlider({ value, onChange, onChangeEnd }: VolumeSliderProps) {
  const dragging = useRef(false);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  }, [onChange]);

  const handleMouseDown = useCallback(() => {
    dragging.current = true;
  }, []);

  const handleMouseUp = useCallback(() => {
    if (dragging.current) {
      dragging.current = false;
      onChangeEnd?.();
    }
  }, [onChangeEnd]);

  return (
    <input
      type="range"
      min={0}
      max={1}
      step={0.01}
      value={value}
      onChange={handleChange}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      className="w-16 h-1 accent-[#07E5B0] cursor-pointer"
      title={`${Math.round(value * 100)}%`}
    />
  );
}
